import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function PageShell({ kicker, title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-[color:var(--dms-cream)]">
      <Navbar />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pt-16 pb-8 text-center">
        {kicker && <p className="kicker">{kicker}</p>}
        <h1 className="font-serif text-4xl md:text-6xl text-[color:var(--dms-navy)] mt-4 leading-tight">{title}</h1>
        <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mx-auto mt-5" />
        {subtitle && <p className="mt-6 text-[color:var(--dms-navy)]/70 max-w-2xl mx-auto">{subtitle}</p>}
      </section>
      <main>{children}</main>
      <Footer />
    </div>
  );
}
